// 简体中文语言包汇总
import pages from "./pages/index.js";
import common from "./common/index.js";
import components from "./components/index.js";
import provinces from "./provinces.js";
import utils from "./utils/index.js";

export default {
  pages,
  common,
  components,
  provinces,
  utils,
  // 为了兼容现有的登录页面翻译键，添加顶级login键
  login: pages.login,
  largesrceen: pages.largesrceen,
  // 添加导航栏翻译键到顶级
  navigation: pages.home.homeheader,
  // 添加home页面翻译键到顶级
  home: pages.home,
  // 添加case模块翻译键到顶级
  case: pages.case,
  historylist: pages.historylist,
  canvas: pages.canvas,
  help: pages.help,
  caseHandlingTool: pages.caseHandlingTool,
  datacase: pages.datacase,
  personalinfo: pages.personalinfo,
  feedback: pages.feedback,
  monitor: pages.monitor,
  model: pages.model,
  balance: pages.balance,
  label: pages.label,
  details: pages.details,
  aiChat: pages.aiChat,
};
